// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accommodation-details-card-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.accommodation-details-card-wrapper .accommodation-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 18px;
  cursor: pointer;
}
.accommodation-details-card-wrapper .accommodation-details-header.remove-border {
  border: none;
  padding: 0;
}
.accommodation-details-card-wrapper .accommodation-details-header span {
  font-size: 22px;
  font-weight: 700;
  color: #000;
}
.accommodation-details-card-wrapper .accommodation-details-header span.open {
  transform: rotate(-90deg);
}
.accommodation-details-card-wrapper .accommodation-details-header span.close {
  transform: rotate(180deg);
}
.accommodation-details-card-wrapper .cabins-detail-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0 18px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper {
  position: relative;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .cabin-slider-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .cabin-slider-wrapper::-webkit-scrollbar {
  display: none;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .cabin-slider-wrapper .cabin-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 22px;
  border-radius: 4px;
  border: 1px solid #93288E;
  cursor: pointer;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .cabin-slider-wrapper .cabin-button span {
  font-size: 18px;
  font-weight: 700;
  color: #93288E;
  white-space: nowrap;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .cabin-slider-wrapper .cabin-button.active {
  background: #93288E;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .cabin-slider-wrapper .cabin-button.active span {
  color: #fff;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .left-arrow {
  position: absolute;
  top: 36%;
  left: -20px;
  cursor: pointer;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .relative-button-wrapper .right-arrow {
  transform: rotate(180deg);
  position: absolute;
  top: 36%;
  right: -20px;
  cursor: pointer;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .cabin-info-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 30px;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .cabin-info-wrapper .cabin-info {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  gap: 12px;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .cabin-info-wrapper .cabin-info .primary-text {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
.accommodation-details-card-wrapper .cabins-detail-wrapper .cabin-info-wrapper .cabin-info .secondary-text {
  font-size: 16px;
  font-weight: 600;
  color: #7f7f7f;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/AccommodationDetailsCard/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;AACR;AACQ;EACI,YAAA;EACA,UAAA;AACZ;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAAZ;AAEY;EACI,yBAAA;AAAhB;AAGY;EACI,yBAAA;AADhB;AAMI;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EAAkB,mBAAA;AAH1B;AAKQ;EACI,kBAAA;AAHZ;AAKY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;AAHhB;AAIgB;EACI,aAAA;AAFpB;AAKgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAHpB;AAKoB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAHxB;AAMoB;EACG,mBAAA;AAJvB;AAKuB;EACC,WAAA;AAHxB;AASY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAPhB;AAUY;EACI,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AARhB;AAYQ;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAVZ;AAYY;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AAVhB;AAYgB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAVpB;AAagB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAXpB","sourcesContent":[".accommodation-details-card-wrapper {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n\n    .accommodation-details-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-bottom: 1px solid #ddd;\n        padding-bottom: 18px;\n        cursor: pointer;\n\n        &.remove-border {\n            border: none;\n            padding: 0;\n        }\n\n        span {\n            font-size: 22px;\n            font-weight: 700;\n            color: #000;\n\n            &.open {\n                transform: rotate(-90deg);\n            }\n\n            &.close {\n                transform: rotate(180deg);\n            }\n        }\n    }\n\n    .cabins-detail-wrapper {\n        display: flex;\n        flex-direction: column;\n        padding: 0 18px;\n        margin-top: 30px; margin-bottom: 20px;\n\n        .relative-button-wrapper {\n            position: relative;\n\n            .cabin-slider-wrapper {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                overflow-x: auto;\n                scroll-behavior: smooth;\n                scrollbar-width: none;\n                -ms-overflow-style: none;\n                &::-webkit-scrollbar {\n                    display: none;\n                }\n\n                .cabin-button {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    padding: 12px 22px;\n                    border-radius: 4px;\n                    border: 1px solid #93288E;\n                    cursor: pointer;\n\n                    span {\n                        font-size: 18px;\n                        font-weight: 700;\n                        color: #93288E;\n                        white-space: nowrap;\n                    }\n\n                    &.active{\n                       background: #93288E;\n                       span{\n                        color: #fff;\n                       }  \n                    }\n                }\n            }\n            \n            .left-arrow {\n                position: absolute;\n                top: 36%;\n                left: -20px;\n                cursor: pointer;\n            }\n\n            .right-arrow {\n                transform: rotate(180deg);\n                position: absolute;\n                top: 36%;\n                right: -20px;\n                cursor: pointer;\n            }\n        }\n\n        .cabin-info-wrapper{\n            display: flex;\n            justify-content: space-between;\n            gap: 20px;\n            flex-wrap: wrap;\n            margin-top: 30px;\n\n            .cabin-info{\n                display: flex;\n                flex-direction: column;\n                min-width: 180px;\n                gap: 12px;\n\n                .primary-text{\n                    font-size: 20px;\n                    font-weight: 500;\n                    color: #000;\n                }\n\n                .secondary-text{\n                    font-size: 16px;\n                    font-weight: 600;\n                    color: #7f7f7f;\n                }\n            }\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
